import React, { useEffect } from 'react'

const SUPPORT_EMAIL = 'xsocks@yahoo.com'
const SUPPORT_TELEGRAM = '@xsocks_support'
const SUPPORT_TELEGRAM_URL = 'https://t.me/xsocks_support'

const HelpModal = ({ isOpen, onClose, zIndex = 10000 }) => {
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                onClose()
            }
        }

        if (isOpen) {
            document.addEventListener('keydown', handleEscape)
            return () => document.removeEventListener('keydown', handleEscape)
        }
    }, [isOpen, onClose])

    if (!isOpen) return null

    return (
        <div
            className="shop-confirm-overlay shop-help-modal-overlay"
            style={{ zIndex }}
            onClick={onClose}
        >
            <div
                className="shop-confirm-modal shop-help-modal shop-confirm-modal--scroll"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    type="button"
                    onClick={onClose}
                    className="shop-confirm-close"
                    aria-label="Close"
                >
                    ✕
                </button>

                <h2 className="shop-confirm-title">Technical Support</h2>

                <div style={{ marginBottom: 'var(--spacing-lg)' }}>
                    <div className="shop-confirm-panel">
                        <h3 className="shop-confirm-section-title shop-help-modal__section-title">
                            📧 Email Support
                        </h3>
                        <p className="shop-confirm-body-text" style={{ marginBottom: 'var(--spacing-sm)' }}>
                            <strong>{SUPPORT_EMAIL}</strong>
                        </p>
                        <p className="shop-confirm-body-muted">
                            Send us an email with your question or issue. We typically respond within 24 hours.
                        </p>
                    </div>

                    <div className="shop-confirm-panel" style={{ marginBottom: 0 }}>
                        <h3 className="shop-confirm-section-title shop-help-modal__section-title">
                            💬 Telegram Support
                        </h3>
                        <p className="shop-confirm-body-text" style={{ marginBottom: 'var(--spacing-sm)' }}>
                            <a
                                href={SUPPORT_TELEGRAM_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="shop-help-modal__contact-link"
                            >
                                {SUPPORT_TELEGRAM}
                            </a>
                        </p>
                        <p className="shop-confirm-body-muted">
                            Get instant help through our Telegram support. Available for quick assistance.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HelpModal
